var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCustomdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_customdate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.44444444,1.77777778 L4.44444444,2.66666667 C4.44444444,3.15733333 4.04622222,3.55555556 3.55555556,3.55555556 C3.06488889,3.55555556 2.66666667,3.15733333 2.66666667,2.66666667 L2.66666667,1.77777778 L2.66666667,0.888888889 C2.66666667,0.398222222 3.06488889,0 3.55555556,0 C4.04622222,0 4.44444444,0.398222222 4.44444444,0.888888889 L4.44444444,1.77777778 Z M11.5555556,1.77777778 L11.5555556,0.888888889 C11.5555556,0.398222222 11.9537778,0 12.4444444,0 C12.9351111,0 13.3333333,0.398222222 13.3333333,0.888888889 L13.3333333,1.77777778 L13.3333333,2.66666667 C13.3333333,3.15733333 12.9351111,3.55555556 12.4444444,3.55555556 C11.9537778,3.55555556 11.5555556,3.15733333 11.5555556,2.66666667 L11.5555556,1.77777778 Z M14.2222222,1.77777778 L14.2266667,1.77777778 C15.2062222,1.77777778 16,2.57333333 16,3.55022222 L16,14.2275556 C16,15.2062222 15.2071111,16 14.2266667,16 L1.77333333,16 C0.793777778,16 0,15.2053333 0,14.2275556 L0,3.55022222 C0,2.57155556 0.792888889,1.77777778 1.77333333,1.77777778 L1.77777778,1.77777778 L1.77777778,2.66666667 C1.77777778,3.65535143 2.573716,4.44444444 3.55555556,4.44444444 C4.54424032,4.44444444 5.33333333,3.64850622 5.33333333,2.66666667 L5.33333333,1.77777778 L10.6666667,1.77777778 L10.6666667,2.66666667 C10.6666667,3.65535143 11.4626049,4.44444444 12.4444444,4.44444444 C13.4331292,4.44444444 14.2222222,3.64850622 14.2222222,2.66666667 L14.2222222,1.77777778 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_customdate",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#42526E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -3.000000)",
    id: "N500"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 21 21 21 21 0 0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1.5 C10,0.671357625 9.32864237,0 8.5,0 C7.67135763,0 7,0.671357625 7,1.5 C7,2.32864237 7.67135763,3 8.5,3 C9.32864237,3 10,2.32864237 10,1.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,1.5 C3,0.671357625 2.32864237,0 1.5,0 C0.671357625,0 0,0.671357625 0,1.5 C0,2.32864237 0.671357625,3 1.5,3 C2.32864237,3 3,2.32864237 3,1.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    x: 1,
    y: 1,
    width: 7,
    height: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomdate);
export default __webpack_public_path__ + "static/media/icon_customdate.28282941fb2e239759866ea0f9984355.svg";
export { ForwardRef as ReactComponent };